import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["report"]

  refresh() {
    if (!this.hasReportTarget || !this.reportTarget.src) return

    const source = new URL(this.reportTarget.src, window.location.href)
    source.searchParams.set("refresh", "1")
    if (this.reportTarget.src === source.href) this.reportTarget.reload()
    else this.reportTarget.src = source.href
  }
}
